var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("CampoUnico", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:80|" + _vm.uniqueFieldRule,
                                    expression:
                                      "`required|max:80|${uniqueFieldRule}`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  id: _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  validate: _vm.validarNombreLista,
                                  message:
                                    " Ya existe una Lista de Distribución con este nombre."
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:200",
                                    expression: "'required|max:200'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.descripcion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.descripcion.id
                                  ),
                                  "data-vv-name": _vm.formFields.descripcion.id,
                                  counter: 200,
                                  disabled: _vm.isVerDetalle
                                },
                                model: {
                                  value: _vm.formFields.descripcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.descripcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.descripcion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br"),
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c(
                          "div",
                          { attrs: { align: "left" } },
                          [
                            _c("v-flex", { attrs: { md12: "" } }, [
                              _c("h2", { staticClass: "h2_title" }, [
                                _vm._v("Lista de Contactos")
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md6: "" } },
                            [
                              _c("BuscadorOperacionCrud", {
                                attrs: {
                                  filter:
                                    _vm.gridApi &&
                                    _vm.gridApi.setQuickFilter.bind(
                                      _vm.gridApi
                                    ),
                                  prepend: "person"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _vm.isVerDetalle
                            ? _c("MantenedorGridVerDetalle", {
                                attrs: {
                                  "grid-options": _vm.computedGridOptions
                                }
                              })
                            : _c("AsociacionGrid", {
                                attrs: {
                                  "grid-options": _vm.computedGridOptions,
                                  esEditar: !_vm.listaSeleccionada
                                    ? false
                                    : true
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }